import React from 'react';
import PageHeader from '../components/PageHeader';
import DistanceVolumeChart from '../components/DistanceVolumeChart';

/** Full-width running volume with the period table. The Dashboard and Fitness pages link here from the chart title. */
const VolumePage: React.FC = () => (
  <>
    <PageHeader title="Training volume">
      <p>Running distance, time and runs per week, month or year. Each bar lists its runs.</p>
    </PageHeader>
    <section className="surface">
      <DistanceVolumeChart variant="page" />
    </section>
  </>
);

export default VolumePage;
